import { Injectable } from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class SelfReportsService {
    url = 'self-report-setting/self-report';
    constructor(public secureApi: SecureApi) {

    }

    search(term: string, countryId: number) {
        return this.secureApi.get('domains/index')['items'];
    }

    read(url, id = 0) {
        return this.secureApi.get( url + '/read/' + id);
    }

    readCustomSR(url, id = 0, step = 0) {
        return this.secureApi.get( url + '/custom-sr/' + id + '/feelings/' + step);
    }

    getAll() {
        return this.secureApi.get('domains/get-all');
    }

    deleteSelfReport(url, item) {
        return this.secureApi.delete(url + '/delete/' + item['id'], false);
    }

    deleteLatestTab(id, url = this.url) {
        return this.secureApi.delete(url + '/custom-sr/' + id + '/delete-steps/', false);
    }

    updateCustomSR(url, data){
        return this.secureApi.post(url + '/custom-sr/' + data['sr_custom_id'] + '/create-steps', data, false);
    }

    getGroupSelection(url, id = 0) {
        return this.secureApi.get( url + '/custom-sr/' + id + '/feeling-groups');
    }
    updateGroupSelection(url, data){
        return this.secureApi.post(url + '/custom-sr/' + data['sr_custom_id'] + '/create-feeling-groups', data, false);
    }
}